module.exports = require('../lib/locale/pt_BR');